import React, {useState } from 'react';
import Alert from '@material-ui/lab/Alert';

export const Error = ({mensaje, handleError}) => {


    return (
        <div>
         <Alert severity="error"  onClose={handleError}>{mensaje}</Alert>
        </div>
    )
}
export default Error;